import React, { useMemo } from "react";
import { OverlayContainerContext } from "./OverlayContainerContext";

export const OverlayContainerProvider: React.FC<{
    children: React.ReactNode;
    containerRef: React.RefObject<HTMLElement | null> | null;
    container?: HTMLElement | null;
}> = ({ children, containerRef, container = null }) => {
    const contextValue = useMemo(
        () => ({
            containerRef,
            container: container ?? containerRef?.current ?? null,
        }),
        [containerRef, container],
    );

    return (
        <OverlayContainerContext.Provider value={contextValue}>
            {children}
        </OverlayContainerContext.Provider>
    );
};
